import { accessToken } from "../../shared/constants/localstorage.constant";

export const getAccessTokenFromStorage = (): string | null =>
  localStorage.getItem(accessToken);
